import { useContext, useEffect } from 'react';
import { AppStateContext } from '../contexts/AppStateContext';
import { useClient } from '../../utils/prismicConfig';
import { StemCountsContext } from '../contexts/StemCountsContext';

const StemCountsChecker = (props) => {
  const { online } = props;

  const [stemCountsDocs, setTermDocs] = useContext(StemCountsContext);
  const [appState] = useContext(AppStateContext);
  const client = useClient(appState);

  useEffect(() => {
    const getTermDocs = async () => {
      if (client) {
        try {
          const stemCountsDocs = await client.getSingle('runkolukutaulukon_lisatiedot');

          setTermDocs(stemCountsDocs);
        } catch (error) {
          console.error(error);
        }
      }
    };

    if (stemCountsDocs.length === 0 && online) {
      getTermDocs();
    }
  }, [client, stemCountsDocs, setTermDocs, online]);

  return null;
};

export default StemCountsChecker;
